import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-109">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="bg-brand-card border border-brand-gold/30 rounded-3xl p-8 md:p-12 relative overflow-hidden" data-id="element-110">
        <div className="absolute top-0 right-0 w-64 h-64 bg-brand-gold/5 rounded-full blur-3xl -z-10" data-id="element-111" />

        <h2 className="text-3xl md:text-4xl font-black text-center mb-10 flex items-center justify-center gap-3" data-id="element-112">
          <Shield className="w-8 h-8 text-brand-gold" data-id="element-113" />
          GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>

        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-114">
          <div className="w-32 h-32 shrink-0 bg-gradient-to-br from-brand-gold to-yellow-600 rounded-full flex items-center justify-center p-1 shadow-[0_0_30px_rgba(245,196,81,0.3)]" data-id="element-115">
            <div className="w-full h-full bg-brand-card rounded-full border-2 border-brand-gold/50 flex flex-col items-center justify-center text-center p-2" data-id="element-116">
              <span className="text-brand-gold font-black text-2xl leading-none" data-id="element-117">
                7
              </span>
              <span className="text-brand-gold text-xs font-bold uppercase tracking-wider" data-id="element-118">
                Días
              </span>
            </div>
          </div>

          <div className="text-center md:text-left" data-id="element-119">
            <p className="text-xl text-gray-300 mb-6 font-medium" data-id="element-120">
              Abrís los tomos. Los aplicás.
              <br data-id="element-121" />
              Si en 7 días no es lo que esperabas:
            </p>

            <div className="text-3xl md:text-4xl font-black text-brand-green mb-2" data-id="element-122">
              DEVOLUCIÓN DEL 100%
            </div>
            <p className="text-gray-400 font-medium mb-6" data-id="element-123">
              sin formularios · sin drama
            </p>

            <div className="inline-block bg-brand-darker border border-brand-green/20 px-4 py-2 rounded-lg text-sm text-gray-400 font-medium" data-id="element-124">
              Tasa de devoluciones: menos del 1%
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}